const { useSelector } = require('react-redux');

const useFeatureFlags = () => {
  const featureFlags = useSelector((state) => state?.featureFlag);
  const featureFlagsFromStorage = localStorage?.getItem('featureFlags');
  if (featureFlags?.isLoading) {
    return featureFlagsFromStorage ? JSON.parse(featureFlagsFromStorage) : {};
  } else {
    return featureFlags;
  }
};

export default useFeatureFlags;
